// extracted by mini-css-extract-plugin
export default {"card":"HomeCard_card__wuAGE"};